import { ClientPortalToggleDefinition } from './types';

export const clientPortalToggleDefinitions: ClientPortalToggleDefinition[] = [
  {
    key: 'enableClientPortalReporting',
    label: 'Enable client portal reporting',
    description: 'Allow clients of this AFSL to access reporting in the client portal.',
  },
];
